import { isMock } from "@/lib/mock-flags";
import * as mock from "./mock";
import * as real from "./real";
import type { NotificationPage } from "../types";
import type { ListNotificationsParams } from "./real";

function pick() {
  return isMock("notifications") ? mock : real;
}

export function listNotifications(params?: ListNotificationsParams): Promise<NotificationPage> {
  return pick().listNotifications(params);
}
export function getUnreadCount(): Promise<number> {
  return pick().getUnreadCount();
}
export function markNotificationRead(id: string): Promise<void> {
  return pick().markNotificationRead(id);
}
export function markAllNotificationsRead(): Promise<void> {
  return pick().markAllNotificationsRead();
}
export function deleteNotification(id: string): Promise<void> {
  return pick().deleteNotification(id);
}

export type { ListNotificationsParams };
